import { useTranslation } from "react-i18next";

import _ from "lodash";
import Schemas from "schemas";

import PopUpWrapper from "./modal-wrapper";

import { Control } from "components/ui-kit/control";
import { Button, Form, Frame, Row } from "components/ui-kit/styled-templates";

import LabsApi from "api/labs-api";

import useFormControl from "hooks/useFormControl";
import useModal from "hooks/useModal";

import { EForms, EModals } from "types/enums";
import VisibilitySwitcher from "../auxiliary/tools/VisibilitySwitcher";

const EditLabModal = () => {
    const { t } = useTranslation();

    const {
        data: formData,
        onSubmit,
        clearForm,
        setValues
    } = useFormControl({
        name: EForms.editLab,
        schema: Schemas[EForms.editLab]
    });
    const { close, state: modalState = {} } = useModal(EModals.CreateLab, {
        onOpen: ({ data = {} }: any) => setValues(data?.details ?? {})
    });
    const { mode, data } = modalState;

    const anyChanges = !_.isEqual(data?.details, formData);

    const handlers = {
        submit: async (details: any) => {
            if (mode === `create`) {
                await LabsApi.createLab(details);
            } else {
                await LabsApi.updateLab({ ...data, details });
            }
            close();
        }
    };
    return (
        <PopUpWrapper name={EModals.CreateLab} onClose={clearForm}>
            <Form name={EForms.editLab} onSubmit={onSubmit(handlers.submit)} extra={`h3 { margin-top: 0; };`}>
                <h3>{mode === `edit` ? `Редактирование объекта научной инфраструктуры` : `Добавить объект научной инфраструктуры`}</h3>

                <Control.Row>
                    <Control.Input name="shareholderName" label={t("3p8df6v8xt5")} placeholder="" />
                </Control.Row>

                <Control.Row>
                    <Control.Input name="inn" label={t("pc3v82x6d9i")} placeholder="" />
                    <Control.Input name="ogrn" label={t("89me1wg8u24")} placeholder="" />
                    <Control.Input name="kpp" label={t("euxb3gjc1zg")} placeholder="" />
                </Control.Row>
                <Control.Row>
                    <Control.Input name="unu" label={t("kb57ac1ri6p")} placeholder="" />
                </Control.Row>

                <Control.Row>
                    <Control.Input name="establishmentYear" placeholder={t("5f41z52f1sy")} label={t("s874axsdpa")} />
                    <Control.Input name="link" label={t("d6iijui9rjc")} placeholder="https://example.com" />
                </Control.Row>

                <Control.Textarea name="departmentalAffiliation" label={t("v7g8fqin8v")} placeholder="" />
                <Control.Textarea name="partnerOrganisations" label={t("zgmpdufuw3")} placeholder="" />

                <Control.Textarea name="legalAddress" label={t("3av0l3kdqv")} placeholder="" />

                <Control.Row>
                    <Control.Input name={`city`} placeholder={t("q5il3syjpje")} label={t("3tkatmlvp8x")} />
                    <Control.Input name={`street`} placeholder={t("8n9f3rr2sbt")} label={t("pr9sxmeigbg")} />
                    <Control.Input name={`houseNumber`} placeholder={t("infvocd2wc")} label={t("e94pq4sjlj")} />
                </Control.Row>

                <Control.Label>{t("pu9i9e02pk")}</Control.Label>

                <Control.Row extra={`align-items: flex-start;`}>
                    <Control.Map name={`coordinates`} extra={`width: 100%; flex: 1;`} />
                    <Frame extra={`width: 100%; flex: 1;`}>
                        <Control.Input name={`coordinates.lat`} placeholder={t("1jin4cxgvlh")} label={t("h0r2moy047")}
                                       regex="[^0-9.]" />
                        <Control.Input name={`coordinates.lng`} placeholder={t("ll0rks5gvc")} label={t("muvpa39wf2")}
                                       regex="[^0-9.]" />
                    </Frame>
                </Control.Row>

                <Control.Textarea name="description" placeholder={t("x8a37e4roa9")} label={t("sm9g9nif5g")} />
                <Control.Textarea name="shortDescription" placeholder={t("tmpwugwxya")} label={t("bxs0oh7o90j")} />

                <Control.Input name={`name`} placeholder="" label={t("ttxj9drmac")} />
                <Control.Input name={`shortName`} placeholder="" label={t("wc5jct2bru")} />

                <Control.Input name={`maxQuantity`} placeholder="" label={t("tm24nzrmt5f")} />

                <Control.Textarea name="rules" label={t("dua47ui53s")} placeholder="" />

                {/*<Control.Row>*/}
                {/*    <Control.Input name="city" placeholder="Текст" label="Город" isRequired />*/}
                {/*    <Control.Input name="address" placeholder="Текст" label="Адрес" isRequired />*/}
                {/*</Control.Row>*/}

                <Control.Input name="owner.name" label={t("vvewgzktcfk")} placeholder="" />
                <Control.Row>
                    <Control.Input name="owner.position" label={t("2wsgow58szs")} placeholder="" />
                    <Control.Input name="owner.phone" label={t("2bniuwxmk9s")} placeholder={t("tpfgs7ln10a")} />
                    <Control.Input name="owner.email" label="Email" placeholder="email" />
                </Control.Row>

                <Control.Input name="unit.name" label={t("ixl3cibtr49")} placeholder="" />
                <Control.Row>
                    <Control.Input name="unit.phone" label={t("15zw9f5cp15")} placeholder={t("pl81tp1xppc")} />
                    <Control.Input name="unit.email" label="Email" placeholder="email" />
                </Control.Row>

                <Control.Input name="admin.name" label={t("5082d1df1fe")} placeholder="" />
                <Control.Row>
                    <Control.Input name="admin.phone" label={t("6dghy9qfm8")} placeholder={t("jrvbgn7q73l")} />
                    <Control.Input name="admin.email" label="Email" placeholder="email" />
                </Control.Row>

                {/**/}

                <Control.File name="photos" label={t("xqau8m9qa0r")} multiple />
                <Control.File
                    name="video"
                    label={t("kto47gay8f")}
                    accept="video/mp4, video/quicktime"
                    maxFilesNumber={1}
                    multiple
                    dropzoneProps={{ label: `Загрузить видео`, icon: `dropzone-video` }}
                />
                {anyChanges && <Control.Error extra={`margin-bottom: 15px;`}>{t("2wi4n57eu8i")}</Control.Error>}

                {/*<Control.Checkbox name="hideMyInfo" placeholder={''} label={'Скрыть информацию для всех пользователей, кроме Администратора Платформы'} />*/}

                {data?.id == undefined ? null :
                    <>
                        {/*@ts-ignore*/}
                        <VisibilitySwitcher
                            dbClassName={"Lab"}
                            id={data?.id}
                            field={"hideFromAll"}
                        />
                    </>
                }

                <Row extra={`width: inherit; justify-content: flex-end; gap: 10px;`}>
                    <Button variant="outlined" background="gray" onClick={close}>
                        {t("6niv212r1oq")}
                    </Button>
                    <Button type="submit" background="green">
                        {t("nxggj3etsx")}
                    </Button>
                </Row>
            </Form>
        </PopUpWrapper>
    );
};

export default EditLabModal;
